<script>
import { random } from 'lodash'

import config from '@/config'

import sound from '@/services/sound'

// Milliseconds
const minInterval = config.textScrollDuration
const maxInterval = 5 * minInterval

// const cursorCharacter = '|'
const cursorCharacter = '█'

const skipCharacters = []

const pauseCharacters = [
  ' ',
  ','
]

const breakCharacters = [
  '\n',
  '.',
  '!',
  '?',
  ';',
  ':'
]

export default {
  name: 'Typewriter',

  props: {

    message: {
      type: String,
      required: true
    },

    // NOTE: Cannot be used to force slow playback when user setting has been set to fast
    fast: {
      default: false
    }

  },

  data () {
    return {
      cursorCharacter,
      cursorIndex: 1,
      timer: null
    }
  },

  computed: {

    // characters () {
    //   return this.message.split('')
    // },

    maxIndex () {
      return this.message.length
    },

    visibleMessage () {
      return this.message.slice(0, this.cursorIndex)
    }

  },

  mounted () {
    this.setNextTimerIteration()

    // FIXME: loop
    sound.play('typewriter1')
  },

  methods: {

    timerCallback () {
      this.cursorIndex++

      if (this.cursorIndex < this.maxIndex) {
        this.setNextTimerIteration()
      } else {
        this.$emit('complete')
      }
    },

    getTimerInterval (lastCharacter) {
      if (skipCharacters.indexOf(lastCharacter) > -1) {
        return 0
      }

      let multiplier = 1
      if (breakCharacters.indexOf(lastCharacter) > -1) {
        multiplier = 8
      } else if (pauseCharacters.indexOf(lastCharacter) > -1) {
        multiplier = 2
      }

      return (this.fast ? 0.25 : this.$store.getters.textScrollingDurationMultiplier) * multiplier * random(minInterval, maxInterval)
    },

    setNextTimerIteration () {
      this.timer = setTimeout(this.timerCallback, this.getTimerInterval(this.visibleMessage.slice(-1)))
    }

  }

}
</script>

<template>
  <div class="c-typewriter">

    <div class="c-typewriter-visible">
      <div class="c-typewriter-content">{{ visibleMessage }}<span class="c-typewriter-cursor">{{ cursorCharacter }}</span></div>
    </div>

    <div class="c-typewriter-ghost">
      <div class="c-typewriter-content">{{ message }}<span class="c-typewriter-cursor">{{ cursorCharacter }}</span></div>
    </div>

  </div>
</template>

<style lang="scss">

.c-typewriter {
  @include relative;
}

.c-typewriter-visible {
  @include fill;
}

.c-typewriter-ghost {
  @include no-pointer-events;
  visibility: hidden;
}

.c-typewriter-content {
  word-wrap: break-word;
  white-space: pre-wrap;
}

.c-typewriter-cursor {
  @include inline-block;
  @include nudge-up(0.225em);
  margin-left: 0.2em;
  font-size: 0.575em;
}

</style>
